import api from 'api/api'
import { toast } from 'react-toastify'
import { FILE_TYPE } from 'constants/index'
import { downloadBase64File } from 'utils'

export const GET_PRODUCT_MOBILITY = '[PRODUCT MOBILITY] GET PRODUCT MOBILITY'
export const RESET_PRODUCT_MOBILITY = '[PRODUCT MOBILITY] RESET PRODUCT MOBILITY'
export const GET_PRODUCT_STOCKS = '[PRODUCT MOBILITY] GET PRODUCT STOCKS'
export const GET_PRODUCT_SERIES = '[PRODUCT MOBILITY] GET PRODUCT SERIES'
export const GET_SERIES_MOBILITY = '[PRODUCT MOBILITY] GET SERIES MOBILITY'
export const GET_SUPPLIERS_BY_PRODUCT = '[PRODUCT MOBILITY] GET SUPPLIERS BY PRODUCT'
export const DOWNLOADING_PRODUCT_MOBILITY = '[PRODUCT MOBILITY] DOWNLOADING PRODUCT MOBILITY'

export function getProductMobility(productIds = []) {
  const request = api.get(`/product-mobility`, { params: { productIds } })
  return (dispatch) => {
    dispatch({ type: GET_PRODUCT_MOBILITY, payload: { loading: true } })
    request.then((response) => {
      dispatch({
        type: GET_PRODUCT_MOBILITY,
        payload: {
          loading: false,
          items: response.data?.data?.items,
          total: response.data?.data?.total,
        },
      })
    }).catch((error) => {
      dispatch({ type: GET_PRODUCT_MOBILITY, payload: { loading: false } })
      console.log(GET_PRODUCT_MOBILITY, error)
    })
  }
}

export function resetProductMobility() {
  return (dispatch) => {
    dispatch({ type: RESET_PRODUCT_MOBILITY, payload: { items: [], total: 0, loading: false } })
  }
}

export function getProductStocks(productIds = []) {
  const request = api.get(`/product-mobility/stocks`, { params: { productIds } })
  return (dispatch) => {
    dispatch({ type: GET_PRODUCT_STOCKS, payload: { loading: true } })
    request.then((response) => {
      dispatch({
        type: GET_PRODUCT_STOCKS,
        payload: {
          loading: false,
          items: response.data?.data?.items,
          total: response.data?.data?.total,
        },
      })
    }).catch((error) => {
      dispatch({ type: GET_PRODUCT_STOCKS, payload: { loading: false } })
      console.log(GET_PRODUCT_STOCKS, error)
    })
  }
}

export function getProductSeriesView(productIds = []) {
  const request = api.get(`/product-mobility/series`, { params: { productIds } })
  return (dispatch) => {
    dispatch({ type: GET_PRODUCT_SERIES, payload: { loading: true } })
    request.then((response) => {
      dispatch({
        type: GET_PRODUCT_SERIES,
        payload: {
          loading: false,
          items: response.data?.data?.items,
          total: response.data?.data?.total,
        },
      })
    }).catch((error) => {
      dispatch({ type: GET_PRODUCT_SERIES, payload: { loading: false } })
      console.log(GET_PRODUCT_SERIES, error)
    })
  }
}

export function getSeriesMobility(serie = '') {
  const request = api.get(`/product-mobility/series-mobility`, { params: { serie } })
  return (dispatch) => {
    dispatch({ type: GET_SERIES_MOBILITY, payload: { loading: true } })
    request.then((response) => {
      dispatch({
        type: GET_SERIES_MOBILITY,
        payload: {
          loading: false,
          items: response.data?.data?.items,
          total: response.data?.data?.total,
        },
      })
    }).catch((error) => {
      dispatch({ type: GET_SERIES_MOBILITY, payload: { loading: false } })
      console.log(GET_SERIES_MOBILITY, error)
    })
  }
}

export function downloadProductMobility(productIds = [], format = 'excel') {
  const url = format === 'pdf' ? `/product-mobility/export-pdf` : `/product-mobility/export`
  const request = api.get(url, { params: { productIds } })
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_PRODUCT_MOBILITY, payload: true })
    request.then((response) => {
      downloadBase64File({
        filename: response.data.nombre,
        fileType: format === 'pdf' ? FILE_TYPE.PDF : FILE_TYPE.EXCEL,
        file: response.data.archivo,
      })
      toast.success(format === 'pdf' ? 'Se descargó el PDF.' : 'Se descargó el EXCEL.')
      dispatch({ type: DOWNLOADING_PRODUCT_MOBILITY, payload: false })
    }).catch((error) => {
      dispatch({ type: DOWNLOADING_PRODUCT_MOBILITY, payload: false })
      toast.error(format === 'pdf' ? 'Algo salió mal. No se pudo descargar el PDF.' : 'Algo salió mal. No se pudo descargar el EXCEL.')
      console.log(DOWNLOADING_PRODUCT_MOBILITY, error)
    })
  }
}

export function downloadProviderProducts(items = [], proveedor = '', format = 'excel') {
  const url = format === 'pdf' ? `/product-mobility/export-provider-pdf` : `/product-mobility/export-provider`
  const request = api.post(url, { items, proveedor })
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_PRODUCT_MOBILITY, payload: true })
    request.then((response) => {
      downloadBase64File({
        filename: response.data.nombre,
        fileType: format === 'pdf' ? FILE_TYPE.PDF : FILE_TYPE.EXCEL,
        file: response.data.archivo,
      })
      toast.success(format === 'pdf' ? 'Se descargó el PDF.' : 'Se descargó el EXCEL.')
      dispatch({ type: DOWNLOADING_PRODUCT_MOBILITY, payload: false })
    }).catch((error) => {
      dispatch({ type: DOWNLOADING_PRODUCT_MOBILITY, payload: false })
      toast.error('No se pudo descargar el reporte.')
      console.log('DOWNLOAD PROVIDER', error)
    })
  }
}

export function downloadSerieMobility(items = [], format = 'excel') {
  const url = format === 'pdf' ? `/product-mobility/export-serie-pdf` : `/product-mobility/export-serie`
  const request = api.post(url, { items })
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_PRODUCT_MOBILITY, payload: true })
    request.then((response) => {
      downloadBase64File({
        filename: response.data.nombre,
        fileType: format === 'pdf' ? FILE_TYPE.PDF : FILE_TYPE.EXCEL,
        file: response.data.archivo,
      })
      toast.success(format === 'pdf' ? 'Se descargó el PDF.' : 'Se descargó el EXCEL.')
      dispatch({ type: DOWNLOADING_PRODUCT_MOBILITY, payload: false })
    }).catch((error) => {
      dispatch({ type: DOWNLOADING_PRODUCT_MOBILITY, payload: false })
      toast.error('No se pudo descargar el reporte.')
      console.log('DOWNLOAD SERIE', error)
    })
  }
}

export function getSuppliersByProduct(productId) {
  const request = api.get(`/product-mobility/suppliers-by-product`, { params: { productId } })
  return (dispatch) => {
    dispatch({ type: GET_SUPPLIERS_BY_PRODUCT, payload: { loading: true } })
    request.then((response) => {
      dispatch({
        type: GET_SUPPLIERS_BY_PRODUCT,
        payload: { loading: false, data: response.data?.data || [] },
      })
    }).catch((error) => {
      dispatch({ type: GET_SUPPLIERS_BY_PRODUCT, payload: { loading: false, data: [] } })
      console.log(GET_SUPPLIERS_BY_PRODUCT, error)
    })
  }
}
